interface GenerationLimitsStatusProps {
  className?: string;
  generationType: string;
  status: {
    canGenerate: boolean;
    errorMessage?: string;
    remaining: number;
    unlimited: boolean;
  } | null;
  loading: boolean;
  error: string | null;
}

export function GenerationLimitsStatus({ className = "", generationType, status, loading, error }: GenerationLimitsStatusProps) {

  if (loading) {
    return (
      <div className={`flex items-center space-x-2 text-sm text-gray-400 dark:text-gray-500 ${className}`}>
        <div className="w-2 h-2 bg-gray-300 dark:bg-gray-600 rounded-full animate-pulse"></div>
        <span>Загрузка ваших лимитов...</span>
      </div>
    );
  }

  if (error) {
    return (
      <div className={`text-red-500 dark:text-red-400 text-sm ${className}`}>
        {error}
      </div>
    );
  }

  if (!status) {
    return null;
  }

  const { canGenerate, errorMessage, remaining, unlimited } = status;

  return (
    <div className={`flex items-center justify-between text-sm ${className}`}>
      <div className="flex items-center space-x-2">
        <div className={`w-2 h-2 rounded-full ${canGenerate ? 'bg-green-500' : 'bg-red-500'}`}></div>
        <span className="text-gray-600 dark:text-gray-400">
          {canGenerate ? 'Генерация доступна' : 'Генерация недоступна'}
        </span>
      </div>
      <div>
        {unlimited ? (
          <span className="text-blue-600 dark:text-blue-400 font-medium">Безлимитно</span>
        ) : (
          <span className={`font-medium ${canGenerate ? 'text-green-600 dark:text-green-400' : 'text-red-600 dark:text-red-400'}`}>
            Осталось: {remaining}
          </span>
        )}
      </div>
    </div>
  );
}
